import React from 'react';

const TermsCondition = () => (
<div className="modal-content p-2">
  <div className="modal-header">
    <h3 className="h4 font-weight-bold mt-0"><i className="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i> 注意事項</h3>
  </div>
  <div className="modal-body">
    <div className="border p-2 mb-3 bg-light rounded">
      <h3 className="h5 font-weight-bold mt-0 mb-1"><span className="text-danger">*</span> お申込みには</h3>
      <p className="fs-sm mb-1">- クレジットカード<br />- 参加者のお名前（パスポートと同じスペル）<br />- 滞在先ホテル名<br />- ツアー当日に利用可能な携帯番号</p>
      <p className="fs-sm mb-0">が必要になります。</p>
    </div>
    <div className="border p-2 mb-3 bg-light rounded">
      <h3 className="h5 font-weight-bold mt-0 mb-1"><span className="text-danger">*</span> カード認証について</h3>
      <img className="img-rounded img-thumbnail mb-2" alt="" src="/themes/travel/dev/images/pending.jpg" />
      <p className="fs-sm mb-0">お申し込み時に、クレジットカードが有効であることと、本人確認のために$0または、$1 がホールドされますが、実際に請求されることはありません（Pending状態）。<br />1日ー7日以内に認証用の$0または、$1はクレジットカード履歴から表示がなくなります。</p>
    </div>
    <div className="border p-2 mb-3 bg-light rounded">
      <h3 className="h5 font-weight-bold mb-1"><span className="text-danger">*</span>
        当サイトでは以下のクレジットカードがご利用可能です。</h3>
      <div className="row row-all-10 mb-3">
        <div className="col">
          <img className="img-rounded img-thumbnail" alt="" src="/themes/travel/dev/images/logo/visa.png" />
        </div>
        <div className="col">
          <img className="img-rounded img-thumbnail" alt="" src="/themes/travel/dev/images/logo/mastercard.png" />
        </div>
        <div className="col">
          <img className="img-rounded img-thumbnail" alt="" src="/themes/travel/dev/images/logo/amex.png" />
        </div>
      </div>
      <p className="desc mb-3 font-weight-bold text-danger">
        JCBカードはオンラインでご利用いただけません。<br />
        ご利用の方はトラトラへお電話にてお申込みください。
      </p>
    </div>
    <h2 className="font-weight-bold h5 mb-1">現地オフィスでもツアーを販売中！</h2>
    <p className="fs-sm">シドニーオフィスの現地スタッフがオーストラリア旅行に関するご質問やご相談にお答えいたします。</p>
    <div className="row row-all-10">
      <div className="col-6 col-md-4 mb-3 mx-auto">
        <img className="rounded border mw-100" src="/v2/images/travel/staff.jpg" alt="" />
      </div>
      <div className="col-12 col-md-8">
        <p><a className="btn btn-block btn-sns btn-sm btn-line gtm-shareLine" href="http://nav.cx/hThOzLX"><img width="18" src="/themes/travel/dev/images/icon/sns-line.png" alt="LINE" /> LINEでお問い合わせ</a></p>
        <p><a className="btn btn-block btn-success btn-sm" href="/contact/travel?type=travel&category=tour"><i className="fa fa-envelope-open" aria-hidden="true"></i> メールでお問い合わせ</a></p>
      </div>
    </div>
  </div>
</div>
);

export default TermsCondition;



// WEBPACK FOOTER //
// ./src/pages/purchase/components/TermsCondition.js